webpackJsonp([125113875506642],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n'], ['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Navigation = __webpack_require__(21);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _styles = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sticky = _styledComponents2.default.div(_templateObject);
	
	var InterieurPage = function (_Component) {
	  _inherits(InterieurPage, _Component);
	
	  function InterieurPage() {
	    _classCallCheck(this, InterieurPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InterieurPage.prototype.render = function render() {
	    var navItems = this.props.data.allNavigationJson.edges;
	    var projecten = this.props.data.allProjectenJson.edges[0];
	
	    var interieurNavItems = navItems.filter(function (_ref, index) {
	      var navItem = _ref.node;
	      return index === 0;
	    });
	
	    var interieurProjecten = projecten.node.projecten.filter(function (project) {
	      return project.type === 'interieur';
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        Sticky,
	        null,
	        _react2.default.createElement(_Navigation2.default, { items: interieurNavItems, navType: 'sub' })
	      ),
	      _react2.default.createElement(
	        _styles.Projects,
	        null,
	        interieurProjecten.map(function (project, index) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              style: { textDecoration: 'none', color: '#000' },
	              to: '/projecten/' + project.type + '/' + project.id,
	              key: index
	            },
	            _react2.default.createElement(
	              _styles.ProjectsWrapper,
	              null,
	              _react2.default.createElement(_styles.ProjectsImage, { src: project.frontImage, alt: '' }),
	              _react2.default.createElement(
	                _styles.ProjectsTitle,
	                null,
	                project.name
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return InterieurPage;
	}(_react.Component);
	
	exports.default = InterieurPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projecten-interieur-js-9047bcb2575aa0beedf7.js